import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Icon } from '../../enums/icon.enum';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ChipComponent {
  displayDefaultIcon = false;
  icon!: Icon;

  @Input() colorClass: string = 'color-dark';
  @Input() backgroundColorClass: string = 'background-color-gray-100';
  @Input() isLoading: boolean = false;
  @Input() skeletonStyles: any = {};
  @Input() set iconName(icon: string) {
    this.displayDefaultIcon = true;
    this.icon = icon as Icon;
  }

  slotChange($event) {
    const assigned = $event.target.assignedNodes();
    if (assigned.length > 0) {
      this.displayDefaultIcon = true;
    }
  }
}
